import Nav from "./Nav";
import Hero from "./Hero";
import City from "./City";
import Life from "./Life";
import Research from "./Research";
import Systems from "./Systems";
import Method from "./Method";
import Experiments from "./Experiments";
import TechStack from "./TechStack";
import WhatsNew from "./WhatsNew";
import Founder from "./Founder";
import OpenSource from "./OpenSource";
import Footer from "./Footer";

export default function Landing() {
  return (
    <div className="bg-gb-bg text-gb-pale font-mono overflow-x-clip">
      <div className="scanlines" aria-hidden="true" />
      <div className="vignette" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <City />
        <Life />
        <Research />
        <Systems />
        <Method />
        <Experiments />
        <TechStack />
        <WhatsNew />
        <Founder />
        <OpenSource />
      </main>
      <Footer />
    </div>
  );
}
